const AtivoEnum = {
    NAO: 'Nao',
    SIM: 'Sim'
}

export default AtivoEnum;